var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAnthropicDark = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FAFAF7",
  d: "m18.436 5.014 8.76 21.972H32L23.24 5.014zM8.273 18.291l2.997-7.721 2.998 7.721zm.486-13.277L0 26.986h4.897l1.792-4.614h9.163l1.791 4.614h4.898L13.78 5.014z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAnthropicDark);
export default ForwardRef;